
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-number-switch]').forEach(s => {
    new NumberSwitch(s)
  });
});


function NumberSwitch (el) {
  this.el = el;
  this.target = document.querySelector(this.el.dataset.numberTarget);
  this.amount = 'numberIncrement' in this.el.dataset ? 1 : -1;
  this.el.addEventListener('click', () => {

    this.clickHandler.call(this);

    window.PubSub.publish('number-switch:click');
  });
}

function clickHandler() {

  this.target.value = Number(this.target.value) + this.amount;

  if (this.target.value < this.target.getAttribute('min')) {
    this.target.value = this.target.getAttribute('min');
  }

  window.PubSub.publish('cart:quantity:update', { quantity: this.target.value, field: this.target });
}
